import { getInstance$, setInstance$ } from '../Observables/Instance.observable';

export const setInstance = (instance: string) => {
  setInstance$(instance);
};

export const getInstance = () => {
  return getInstance$();
};
